import { render, staticRenderFns } from "./view-project-member.vue?vue&type=template&id=76111054&"
import script from "./view-project-member.vue?vue&type=script&lang=js&"
export * from "./view-project-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports